
import React, { createContext, useContext, useState } from 'react';
import { Book } from '@/utils/books/types';

interface BookContextType {
  book: Book | null;
  setBook: (book: Book | null) => void;
}

const BookContext = createContext<BookContextType>({
  book: null,
  setBook: () => {}
});

export const BookProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [book, setBook] = useState<Book | null>(null);

  return (
    <BookContext.Provider value={{ book, setBook }}>
      {children}
    </BookContext.Provider>
  );
};

export const useBook = () => useContext(BookContext);
